<div class="row">
  <div class="col-sm-12">
    <h1>{{ 'mailLog' | translate }}</h1>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <mail-log-table #mailLogTable [emails]="emails" (refresh)="getEmails()" ></mail-log-table>
  </div>
</div>